import pino from 'pino';

const level = 'info';

export const logger = pino({
  name: 'next-app-server',
  level,
});
